import { render, staticRenderFns } from "./CustomPayment-RWS.vue?vue&type=template&id=31970bb8&scoped=true&"
import script from "./CustomPayment-RWS.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-RWS.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-RWS.vue?vue&type=style&index=0&id=31970bb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31970bb8",
  null
  
)

export default component.exports